module.exports = __webpack_public_path__ + "cd8d0b7418c27e36ddb9b7e3e6ceff11.png";